import { DateTime } from 'luxon';
import FooterMadeBy from './FooterMadeBy'

export default function Footer (props)
{
	return (
		<footer className="c-footer">

			{
				props.layout !== 'entity' ?
				(
					<div className="c-footer__legal">
						<a href="/infos-legales/pdc"
							className="c-footer__legal-puc-cgu-cgv">
							Politique de confidentialité
						</a>

						<a href="/infos-legales/puc"
							className="c-footer__legal-puc-cgu-cgv">
							Politique d'utilisation des cookies
						</a>

						<a href="/infos-legales/cgu"
							className="c-footer__legal-puc-cgu-cgv">
							Conditions générales d'utilisation
						</a>

						<a href="/infos-legales/cgv"
							className="c-footer__legal-puc-cgu-cgv">
							Conditions générales de vente
						</a>
					</div>
				)
				: undefined
			}

			<div className="c-footer__bottom">

				<div className="o-container c-footer__bottom-container">
					<div className="c-footer__legal-copyright">
						<p>
							Groupe Beroki ©
							{ ' ' }
							{ DateTime.now().toFormat('yyyy') }
						</p>
					</div>

					<FooterMadeBy />
				</div>

			</div>

		</footer>
	);
}